import type {SyncIntegration} from '@cohort/merchants/apps';
import SpotifySyncConfigComponent from '@cohort/merchants/apps/spotify/sync/SyncConfigComponent';
import type {SpotifySyncStruct} from '@cohort/shared/apps/spotify/sync';
import {SpotifySyncSpec} from '@cohort/shared/apps/spotify/sync';

export const SpotifySyncIntegration: SyncIntegration<SpotifySyncStruct> = {
  spec: SpotifySyncSpec,
  syncConfigComponent: SpotifySyncConfigComponent,
};
